import {
  createMpListSortable,
  destroySortableInstance,
  reorderMpList,
} from '@/utils/mpListSortable'

/**
 * 控件 mpList 横向素材列表拖拽排序 mixin。
 * 使用方需提供 computed：mpListSortableConfig → { listRef, itemSelector }
 * 并依赖 props.lists、mapState 的 controlIndex / componentsList。
 */
export default {
  data() {
    return {
      mpListSortableInstance: null,
    }
  },
  watch: {
    controlIndex() {
      this.$nextTick(() => {
        this.rebindMpListSortable()
      })
    },
    'lists.length'() {
      this.$nextTick(() => {
        this.rebindMpListSortable()
      })
    },
  },
  beforeDestroy() {
    this.destroyMpListSortable()
  },
  methods: {
    destroyMpListSortable() {
      destroySortableInstance(this.mpListSortableInstance)
      this.mpListSortableInstance = null
    },

    rebindMpListSortable() {
      this.destroyMpListSortable()
      this.$nextTick(() => {
        this.initMpListSortable()
      })
    },

    initMpListSortable() {
      const config = this.mpListSortableConfig
      if (!config || !config.listRef || !config.itemSelector) return

      this.destroyMpListSortable()
      const el = this.$refs[config.listRef]
      if (!el || !this.lists || this.lists.length < 2) return

      this.mpListSortableInstance = createMpListSortable(el, {
        draggable: config.itemSelector,
        sortableOptions: config.sortableOptions,
        onReorder: (oldIndex, newIndex) => {
          const list = this.componentsList[this.controlIndex].mpList
          if (!reorderMpList(list, oldIndex, newIndex)) return
          this.$nextTick(() => {
            this.rebindMpListSortable()
          })
        },
      })
    },
  },
}
